import { createApi } from '@reduxjs/toolkit/query/react';
import { identityBaseQuery } from '../../lib/axiosBaseQuery';

export const workflowApi = createApi({
  reducerPath: 'workflowApi',
  baseQuery: identityBaseQuery,
  tagTypes: ['Workflows', 'WorkflowAudits'],
  endpoints: (builder) => ({
    getWorkflows: builder.query<any, void>({
      query: () => ({
        url: `Workflow/all`,
        method: 'GET',
      }),
      providesTags: ['Workflows'],
    }),
    createWorkflow: builder.mutation<void, Record<string, any>>({
      query: (data) => ({
        url: `Workflow/create-workflow`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Workflows'],
    }),
    updateWorkflow: builder.mutation<void, Record<string, any>>({
      query: (data) => ({
        url: `Workflow/update-workflow`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['Workflows'],
    }),
    deleteWorkflow: builder.mutation<void, string>({
      query: (id) => ({
        url: `Workflow/delete-workflow/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Workflows'],
    }),
    getWorkflowAudits: builder.query<any, void>({
      query: () => ({
        url: `workflow/audits`,
        method: 'GET',
      }),
      providesTags: ['WorkflowAudits'],
    }),
    removeUserFromWorkflow: builder.mutation<void, { workflowId: string; userId: string }>({
      query: ({ workflowId, userId }) => ({
        url: `workflow/${workflowId}/remove/${userId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Workflows'],
    }),
  }),
});

export const {
  useGetWorkflowsQuery,
  useCreateWorkflowMutation,
  useUpdateWorkflowMutation,
  useDeleteWorkflowMutation,
  useGetWorkflowAuditsQuery,
  useRemoveUserFromWorkflowMutation,
} = workflowApi;
